// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"96b6257b","495":"e0dd7c09","533":"8e80eb81","783":"3f078530","977":"41bb06e5"}[chunkId] + ".chunk.js";
};